import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'timer' })
export class TimerPipe implements PipeTransform {
    transform(seconds: number): string {
        return moment(seconds, 'ss').format('mm:ss');
    }
}
